import React from 'react';
import MainRouter from './Components/MainRouter'
import './App.css';

function App() {
  return (
    <div className="App">
      <MainRouter></MainRouter>
    </div>
  );
}

export default App;
